import React from 'react';
import { Box, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { CustomerStatus } from '@trnsact/trnsact-shared-types';
import { customerStatusChipSettings } from 'modules/customers/constants';

interface Props {
  status: CustomerStatus;
}

export const CustomerStatusChip = ({ status }: Props) => {
  const classes = useStyles(customerStatusChipSettings[status]);

  return (
    <Box className={classes.container}>
      <Typography align="center" component="span" variant="body2">
        {status}
      </Typography>
    </Box>
  );
};

const useStyles = makeStyles<Theme, { color: string; bgColor: string; borderColor: string }>({
  container: {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '4px',
    padding: '4px 10px',
    border: '1px solid',
    color: ({ color }) => color,
    backgroundColor: ({ bgColor }) => bgColor,
    borderColor: ({ borderColor }) => borderColor,
  },
});
